<div class="chubbTermsDetail" [class.inner-view]="innerView">
  <ng-container *ngIf="!innerView">
    <div class="chubbTermsDetail__header">
      <div class="image-cont">
        <img class="img-logo" loading="lazy" [src]="CHUBB_LOGO | baseImage: CHUBB_BOOKING_IMAGES_BASE_PATH">
      </div>
      <div class="close" (click)="closeDetail.emit()">
        <span><i aria-hidden="true" class="icon-close"></i></span>
      </div>
    </div>
  </ng-container>
  <div class="chubbTermsDetail__body">
    <div class="chubbTermsDetail__body-switch">
      <div class="pill" [class.active]="isActiveDetails" (click)="toggleTermsIsActive(false)">
        <span>{{valuesLabel}}</span>
      </div>
      <div class="pill" [class.active]="isActiveTerms" (click)="toggleTermsIsActive(true)">
        <span>{{termsLabel}}</span>
      </div>
    </div>
    <div class="chubbTermsDetail__body-text" [class.cross-selling]="isCrossSelling">
      <ng-container *ngIf="!!isActiveTerms; else valuesTemplate">
        <ng-container *ngTemplateOutlet="termsTemplate"></ng-container>
      </ng-container>
    </div>
  </div>
</div>

<ng-template #valuesTemplate>
  <div class="cont-values-detail">
    <ng-container *ngFor="let value of assistanceValues; first as isFirst">
      <div class="content-row-ext">
        <div class="row-cont-info">
          <span class="value-title-row" [class.only-title]="!isFirst">
            {{ value.Category }}
          </span>
          <span *ngIf="!!isFirst">{{ insuredLimitLabel }}</span>
        </div>
        <div class="row-cont-inclusion" *ngFor="let inclusion of value.Inclusions">
          <span class="inclusion-title">{{ inclusion.Text }}</span>
          <span class="inclusion-price">
            {{ inclusion.Amount | currencyFormat: inclusion.CurrencyCode }}
          </span>
        </div>
      </div>
    </ng-container>
  </div>
</ng-template>

<ng-template #termsTemplate>
  <div class="content-terms-conditions">
    <div class="box-content">
      <h3 *ngIf="termsContTitle" class="principal-title">{{termsContTitle}}</h3>
      <ng-container *ngIf="!!terms?.length">
        <ng-container *ngFor="let item of terms">
          <ng-container *ngIf="!!item.TITLE">
            <p class="title"><strong>{{item.TITLE}}</strong></p>
          </ng-container>
          <ng-container *ngFor="let paragraph of item.PARAGRAPHS">
            <p [innerHTML]="paragraph"></p>
          </ng-container>
        </ng-container>
      </ng-container>
      <span class="link-chubb-pdf" *ngIf="!!srcPdf" (click)="openPDF()">
        {{ 'ASSISTANCE_MODULE.USER_HISTORY_ASSISTANCE_DETAIL.ASSISTANCE_VIEW_DOCUMENT' | transloco }}
      </span> 
    </div>
  </div>
</ng-template>


<app-swipe-up *ngIf="showPdf" [height]="85" [showSwipeUp]="showPdf" (toggleShowSwipeUp)="toggleOpenPdfView()">
  <ng-container content>
    <div class="modal-pdf">
      <div class="button-close-modal">
        <i aria-hidden="true" (click)="toggleOpenPdfView()" class="icon-close"></i>
      </div>
      <div class="content-pdf" *ngIf="showPdf">
        <app-pdf-viewer [srcPdf]="srcPdf"></app-pdf-viewer>
      </div>
    </div>
  </ng-container>
</app-swipe-up>